import AccountModel from './accountModel';
import Service from '../services/services';

class AddressConfigModel extends AccountModel{
    constructor() {
        super();
        this.countries = [];  //countries from service
        this.groupType = '';
        this.localeRegions = [];
        this.selectedCountry = '';
        this.selectedCountryRegions = '';
        this.initialized = {
            countries : {},
            localeRegions: {}
        };
    }

    setSelectedCountry(model, selector, modelProperty, session, serviceMethod) {
        let countryId = jQuery(selector).val();

        return new Promise((resolve,reject)=>{
            resolve(super.setData(countryId, modelProperty, true));
        })
    }

    clearSelectedCountry(model, selector, modelProperty) {
        this.selectedCountry = '';
        return Promise.resolve(super.setData(this.selectedCountry, modelProperty, true));
    }

    setCountryGroupType(model, selector, modelProperty) {
        const country = jQuery(selector).val(); ;
        const countries = this.countries;

        let setGroupType = _.get(_.find(countries, (aCountry) => aCountry.countryCode === country), 'groupType');

        return new Promise((resolve,reject)=> {
            resolve(super.setData(setGroupType, modelProperty, true));
        });
    }

    clearSelectedCountryRegions(model, selector, modelProperty) {
        this.selectedCountryRegions = '';
        return Promise.resolve(super.setData(this.selectedCountryRegions, modelProperty, true));
    }

}

let AddressConfig = new AddressConfigModel();

export default AddressConfig;
